/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE API : CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
    controls: {
        flex: replacePXinStringWithEM('0 0 110px'),
        width: '100%',
        position: 'relative',
        '& .innerControls': {
            '& .field.name-imagetype': {
                display: 'none',
                marginBottom: pxToEm(12) // same as imageTypes
            },
            '& .searchbar': {
                margin: '0'
            }
        }
    }
});
